import { BooleanIcon, getBooleanColors } from "./utils";

import { BaseCell, BaseCellProps } from ".";

export interface BooleanCellProps extends Omit<BaseCellProps, "children" | "value"> {
  value: boolean;
  showColors?: boolean;
  trueLabel?: string;
  falseLabel?: string;
  showLabels?: boolean;
  iconSize?: "sm" | "md" | "lg";
}

export const BooleanCell = ({
  value,
  showColors = true,
  trueLabel = "true",
  falseLabel = "false",
  showLabels = false,
  ...baseCellProps
}: BooleanCellProps) => {
  const colorClasses = showColors ? getBooleanColors(value) : "";

  return (
    <BaseCell
      {...baseCellProps}
      borderColor={
        value
          ? `border-green-200 ${baseCellProps.isSelected ? "!border-blue-200 !bg-blue-50" : ""}`
          : `border-red-200 ${baseCellProps.isSelected ? "!border-blue-200 !bg-blue-50" : ""}`
      }
    >
      <span className={`flex h-full w-full items-center justify-center ${colorClasses}`}>
        {showLabels ? (
          <span className="text-sm font-medium">{value ? trueLabel : falseLabel}</span>
        ) : (
          <BooleanIcon value={value} />
        )}
      </span>
    </BaseCell>
  );
};
